/*--------------------------------------------------
Script name: 	   CG Main
Author:			   Craig Collins, Ashley Robbins, Martin Doychinov, Louie Colgan
Version:		   0.1
Created:	       07/12/2015
Notes:             Main JavaScript file for C&G.com widgets page
References:        BigBird-level5.1.0.0.js, interact.1.0.0.js, core.1.0.1.js
------------------------------------------------*/
$(window).on("load", function (e) {

    if (!$('.scChromeToolbar').length) {

        /*
            1. IMAGE TEXT WIDGET EQUAL HEIGHTS
            2. HOMEPAGE CAROUSEL
            3. INTERACTIVE MAP
            4. ACCORDION
            5. VIDEO SWITCH
            6. VIDEO/PICTURE GALLERY
            7. BREADCRUMB STYLING
            8. ADD CONDITIONAL CLASSES AND STYLES
            9. ADD MARGIN AND PADDING IF BACKGROUND IMAGE ADDED
            10. RAJ NAVIGATION WIDGET
            11. RAJ DYNAMIC STANDARD TWO COLUMN TEMPLATE WIDTH
            12. RAJ SEARCH PAGE LAYOUT CHANGES
            13. SEARCH PAGE RESULTS SORTING
            14. FOOTER SECTION MOBILE ACCORDIONS
            15. FOOTER LOGO SECTION EVEN SPACING
            16. MOBILE SEARCH SHOW/HIDE
            17. MOBILE NAVIGATION
            18. TEXTWIDGET ACCORDION
            19. CLEAR OUT EMPTY DIVS FROM WIDGETWRAPPER
            20. NEWS ARCHIVE WIDGET ACCORDIONS
        */

        /* 1. IMAGE TEXT WIDGET EQUAL HEIGHTS
        ------------------------------------------*/
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

        $('.equalHeights > div').each(function () {
            $el = $(this);
            topPosition = $el.position().top;
            if (currentRowStart != topPosition) {
                // we just came to a new row.  Set all the heights on the completed row
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                // set the variables for the new row
                rowDivs.length = 0; // empty the array
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                // another div on the current row.  Add it to the list and check if it's taller
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            // do the last row
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });

        /* 2. HOMEPAGE CAROUSEL 
        ------------------------------------------*/
        if ($("#home-carousel > ul li").length > 1) {
            var mainCarousel = new bigBird({
                wrap: "#home-carousel",
                speed: 1000,
                interval: 4000
            });
        };

    /* 3. INTERACTIVE MAP 
    ------------------------------------------*/
    //$("#interactiveMap .mapPointOctagon, #interactiveMap .mapPointLabel h4").off().on("click", function () {
    //    var overlayToShow = $(this).attr("data-overlay-to-show");
    //    $("#interactiveMap .overlay").removeClass("active");
    //    $("#" + overlayToShow).addClass("active");
    //    $("#background").addClass('active');
    //    // Scroll to top of map
    //    $('html, body').animate({
    //        scrollTop: $("#interactiveMap").offset().top - 100
    //    }, 500, 'swing');
    //    // On click close
    //    $("#interactiveMap .closeOverlay").off().on("click", function () {
    //        stopPlayback(closeOverlay);
    //        return false;
    //    });
    //});

    //var closeOverlay = function () {
    //    // Close overlay
    //    $("#interactiveMap .overlay").removeClass("active");
    //    $("#background").removeClass('active');
    //};

    //var stopPlayback = function (callback) {
    //    // Stop YouTube video playing
    //    var url = $('#interactiveMap .overlay.active iframe').attr('src');
    //    $('#interactiveMap .overlay.active iframe').attr('src', '');
    //    $('#interactiveMap .overlay.active iframe').attr('src', url);
    //    callback();
    //};

    /* 4. ACCORDION
    ------------------------------------------*/
    var accordion = new interact.accordion({
        wrapper: '.accordionWrapper',
        selector: '.accordionTitle',
        multiOpen: true,
        checkUrl: true,
        active: false
    });

        /* 5. VIDEO SWITCH
        ------------------------------------------*/
        $(".videoSwitchThumb").off().on("click", function () {
            videoUrl = $(this).find('img').attr("data-video-src");
            $("#video").attr("src", videoUrl);
            $('.videoSwitch').addClass('active');
        });

        /* 6. VIDEO/PICTURE GALLERY
        ------------------------------------------*/
        var lightbox = (function () {
            'use strict';
            /// Default options
            var opt = {
                selector: $('.lightbox'),
                closeSelector: $('#closeBox'),
                background: $('#background'),
                content: $('#modal')
            }
            /// Open
            var openContent = function () {
                // Content to open
                var contentToShow = $(this).attr('href');
                // Show overlay
                // Add content to overlay
                if ($(this).hasClass('iframe')) {
                    opt.background.addClass('active');
                    opt.content.addClass('active');
                    opt.content.append('<div class="videoContainer"><iframe src="' + contentToShow + '" frameborder="0" allowfullscreen></iframe></div>');
                } else {
                    opt.background.addClass('active');
                    opt.content.addClass('active');
                    opt.content.append('<img class="largeImage" src="' + contentToShow + '" />');
                    $('#modal img').load(function () {
                        opt.content.css('width', $('.largeImage').innerWidth());
                    });
                };
                // Position video
                var positionVideo = Core.debounce(function () {
                    opt.content.css('margin-top', ($(window).height() / 2) - (opt.content.innerHeight() / 2) + $(window).scrollTop());
                }, 250);
                // Reposition video on window resize
                Core.bindEvent(window, 'resize', function () {
                    positionVideo();
                });
                positionVideo();
                return false;
            };
            /// Close
            var closeContent = function () {
                // Remove overlay
                opt.background.removeClass('active');
                opt.content.removeClass('active');
                opt.content.removeAttr('style')
                // Remove content of overlay
                $('.largeImage, .videoContainer').remove();
                return false;
            };
            /// Clicks
            var clicks = function () {
                // Image click
                opt.selector.on('click', openContent);
                // Close click
                opt.closeSelector.on('click', closeContent);
            }();
        })();

        /* 7. BREADCRUMB STYLING
        ------------------------------------------*/

        var resizeTimer;
        $(window).on('resize', function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {

                if ($("#carouselWidget, #heroImageWidget").length) {
                    var heroHeight = $("#carouselWidget, #heroImageWidget").outerHeight();
                    heroHeight += 30;

                    $("#breadcrumb").addClass("light").css({
                        "position": "absolute",
                        "top": heroHeight
                    });
                };

            }, 250);
        });

        if ($("#carouselWidget, #heroImageWidget").length) {
            var heroHeight = $("#carouselWidget, #heroImageWidget").outerHeight();
            heroHeight += 30;

            $("#breadcrumb").addClass("light").css({
                "position": "absolute",
                "top": heroHeight
            });
        };

        if ($(".dcorange")[0]) {
            $("#breadcrumb .last").addClass("bcrumborange");
        };

        /* 8. ADD CONDITIONAL CLASSES AND STYLES
        ------------------------------------------*/
        if ($("#cgWrap")[0]) {
            $(".bg").addClass("background");
            //$("#footer").css({ 'margin-top': '-59px' });

            $("#nav #main-nav").addClass("fw");
            $("#nav #sub-nav").addClass("fw");
            $("#alert-banner").addClass("fw");
            $("#info-bar").addClass("fw");
            $("#header").addClass("fw");
            $("#heroImageWidget .imageContainer").addClass("fw");
            $("#footer").addClass("fw");
            $(".footer-row").addClass("fw");
            $(".footer-links").addClass("fw");
            $("#footer-base-links").addClass("fw");
            $("#site-logos").addClass("fw");
            
        }

        /* 9. ADD MARGIN AND PADDING IF BACKGROUND IMAGE ADDED
        ------------------------------------------*/
        for (var i = 0; i < $('.fullWidth').length; i++) {
            var bgUrl, absoluteImg, pageHref = '';
            bgUrl = $('.fullWidth').eq(i).css('background-image');
            absoluteImg = bgUrl.slice(4, -1).replace(/["']/g, "");
            pageHref = window.location.href;

            $('.fullWidth').eq(i).css({ 'margin': '0', 'padding': '0' }).removeClass('stretched-bg');

            if (absoluteImg == pageHref) {
                $('.fullWidth').eq(i).attr('style', '').css({ 'margin': '0', 'padding': '0' }).removeClass('stretched-bg');
            } else if (absoluteImg !== 'none' && absoluteImg != '') {
                $('.fullWidth').eq(i).css({ 'margin': '0 -100%', 'padding': '60px 0', 'background-repeat': 'no-repeat', 'background-position': 'center center', 'background-size': 'cover' }).addClass('stretched-bg');
            }
        }

        /* 10. RAJ NAVIGATION WIDGET
        ------------------------------------------*/
        if ($(".rajNavWidget")[0]) {

            // Toggle viewing the sub navigation
            $(".rajNavWidget__toggle").on("click", function (e) {

                var _this = $(this);
                var item = _this.closest(".rajNavWidget__item");
                var subNav = _this.siblings(".rajNavWidget__list");

                _this.toggleClass("open");
                item.toggleClass("open");
                subNav.toggleClass("rajNavWidget__list--open");

            });

            function openSecondaryNav() {
                var $widgetSecondaryNav = $('#sub-nav-level2');
                $widgetSecondaryNav.addClass('rajNavWidget__list--open');
            }

            /**
             * Expand the navigation tree from the current page
             * link. Involves recursively looking up the tree,
             * finding the parent dropdown and ensuring the parent dropdown
             * is opened. 
             */
            $.each($('.rajNavWidget'), function (i, navWidget) {

                var currentPageClass = '.rajNavWidget__item--current';
                var toggleActiveItemClass = '.rajNavWidget__toggle';
                var navItemClass = 'rajNavWidget__item';
                var navListClass = 'rajNavWidget__list';
                var activeItemClass = 'rajNavWidget__item--active';

                var $widget = $(navWidget);
                var $current = $($widget.find(currentPageClass));

                if (!$current.length) {
                    openSecondaryNav();
                    return false;
                }

                // Check whether the current nav item contains a sub navigation.
                var $currentToggleBtn = $current.find(toggleActiveItemClass).first();

                // Get the current nav item's parent holder.
                var $currentNav = $current.parent().parent();

                // If the current link contains a sub-navigation, expand it.
                if ($currentToggleBtn.length && !$currentToggleBtn.hasClass('open')) {
                    $currentToggleBtn.trigger('click');
                }

                // Find the ancestors of the current nav item, recursively iterate
                // through the holder's parents and trigger the nav dropdown.
                (function openParentNav($el) {

                    var isNavItem = $el.hasClass(navItemClass) || $el.hasClass(navListClass);

                    if (!isNavItem || !$el.parent().length) {
                        openSecondaryNav();
                        return false;
                    }

                    var $toggleBtn = $el.find(toggleActiveItemClass).first();

                    if ($toggleBtn.length && !$toggleBtn.hasClass('open') && $el.hasClass(navItemClass)) {
                        $el.addClass(activeItemClass);
                        $toggleBtn.trigger('click');
                    }

                    return openParentNav($el.parent());

                })($currentNav);

            });

        }

        /* 11. RAJ DYNAMIC STANDARD TWO COLUMN TEMPLATE WIDTH
        ------------------------------------------*/
        if ($('.sidebar__stdpage') && !$('.sidebar__stdpage').children().length) {
            $('.maincontent__stdpage').css({ 'width': '100%' });
        }

        /* 12. RAJ SEARCH PAGE LAYOUT CHANGES
        ------------------------------------------*/
        if ($('.share-search').length) {
            $('#right-rail').hide();
            $('#sl5').css('width', '100%');

            var pageTitle = $('.pageTitle')[0],
                pageTitleText = $(pageTitle).text(),
                pageTitleSpan = '<span>' + pageTitleText + '</span>';
            $('body').addClass('searchPage');
            $(pageTitle).addClass('search').text('');


            var shareSearch = $('.share-search');
            shareSearch.remove();

            $(pageTitleSpan).prependTo('.pageTitle');
            $(shareSearch).appendTo('.pageTitle').addClass('show');
            $('body').addClass('show');

            var resultSummaries = $('.resultSummary');
            for (var i = 0; i < resultSummaries.length; i++) {
                var p = $(resultSummaries[i]).find("p");

                for (var a = 0; a < p.length; a++) {
                    var pText = $(p[a])[0].innerText;

                    if (pText == "") {
                        $(p[a]).remove();
                    }
                }
            }
        }

        /* 13. SEARCH PAGE RESULTS SORTING
        ------------------------------------------*/
        $('#SortBySelect').on('change', function () {
            var _this = $(this);
            index = _this[0].selectedIndex,
                option = $(_this[0].options[index]),
                searchUrl = option[0].dataset.searchUrl,
                newUrl = window.location.origin + searchUrl;

            document.location.assign(newUrl);
        });

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        if (getParameterByName('s') == 'relevance') {
            $('#SortBySelect option:first-child').attr('selected', 'selected');
        } else if (getParameterByName('s') == 'title') {
            $('#SortBySelect option:last-child').attr('selected', 'selected');
        }

        /* 14. FOOTER SECTION MOBILE ACCORDIONS
        ------------------------------------------*/
        $('.footer-row h3').on('click', function () {
            var _this = $(this),
                list = _this.next('ul');

            _this.toggleClass('active');
            list.toggleClass('show');
        });

        /* 15. FOOTER LOGO SECTION EVEN SPACING
        ------------------------------------------*/
        function styleFooterLogos() {
            var windowWidth = window.innerWidth;

            if (windowWidth < 1000) {
                $('#site-logos li').removeAttr('style');
            } else {
                $('#site-logos li').evenSpacer();
            }
        }
        styleFooterLogos();
        window.onresize = function (event) {
            styleFooterLogos();
        };

        /* 16. MOBILE SEARCH SHOW/HIDE
        ------------------------------------------*/
        $('#search-trigger').on('click', function () {
            $(this).toggleClass('active');
            $('#header-search').toggleClass('open');
            $('#page').toggleClass('fixed');
            $('#root-content, #footer').toggleClass('faded');
        });

        $(window).resize(function () {
            if ($(window).width() > 999 && $('#header-search').hasClass('open')) {
                $('#search-trigger').removeClass('active');
                $('#header-search').removeClass('open');
                $('#page').removeClass('fixed');
                $('#root-content, #footer').removeClass('faded');
            }
        });

        /* 17. MOBILE NAVIGATION
        ------------------------------------------*/
        $('#nav-trigger').on('click', function () {
            $(this).toggleClass('active');
            $('#mobile-nav').toggleClass('open');
            $('#page').toggleClass('fixed');
            $('#root-content, #footer').toggleClass('faded');
        });


        $(window).resize(function () {
            if ($(window).width() > 999 && $('#mobile-nav').hasClass('open')) {
                $('#nav-trigger').removeClass('active');
                $('#mobile-nav').removeClass('open');
                $('#page').removeClass('fixed');
                $('#root-content, #footer').removeClass('faded');
            }
        });

        $('#mobile-nav > li > a .mobile-nav-toggle').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var parent = $(this).closest('li');

            $(parent).toggleClass('open');
            $(parent).find('> #sub-nav').slideToggle(positionMobileInfoBar);
        });

        $('.mobile-nav-footer-link .mobile-nav-toggle').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var parent = $(this).closest('li');

            $(parent).toggleClass('open');
            $(parent).find('> #sub-nav').slideToggle(function () {
                if ($(parent).hasClass('open')) {
                    $('.mobile-nav-footer').css('position', 'relative');
                } else {
                    $('#mobile-nav').scrollTop(0);
                    positionMobileInfoBar();
                }
            });
        });

        function positionMobileInfoBar() {
            var windowHeight = window.innerHeight,
                lastNav = $('#mobile-nav > li:last-of-type'),
                lastNavPos = lastNav[0].getBoundingClientRect(),
                lastNavOffset = lastNavPos.top,
                lastNavHeight = $(lastNav)[0].scrollHeight;

        }
        positionMobileInfoBar();

        window.onresize = function (event) {
            positionMobileInfoBar();
        };

        /* 18. TEXTWIDGET ACCORDION
        ------------------------------------------*/
        $('.textwidget_title').on('click', function () {
            $(this).closest('.textwidget').toggleClass('open');
        });

        $('a').on('click', function (e) {
            for (var i = 0; i < $(this).length; i++) {
                setTimeout(function () {
                    if (window.location.hash) {
                        if (!$(window.location.hash).hasClass("open")) {
                            // click on the accordion.
                            $(window.location.hash).trigger('click');
                        }
                    }
                }, 100);
            }
        });

        /* 19. CLEAR OUT EMPTY DIVS FROM WIDGETWRAPPER
        ------------------------------------------*/
        $('.widgetWrapper > .marginBottomDouble').each(function () {
            if ($(this).html().length < 1) {
                $(this).remove();
            }
        });

        /* 20. NEWS ARCHIVE WIDGET ACCORDIONS
        ------------------------------------------*/
        $('.archive-year-label').on('click', function () {
            $(this).toggleClass('open');
            $(this).next('.archive-year-list').slideToggle();
        });


        /* 21. TAB LIST ACCORDION  
------------------------------------------*/
        $('.tab-list--item a').on('click', function (e) {
            e.preventDefault();
            var container = $(this).closest('.tab-component');

            container.find('.tab-list--item.active').removeClass('active');
            $(this).parent('li').addClass('active');

            var tabItem = $(this).attr('data-tab');
            var panelItem = container.find(".tab-list--content").find("[data-panel='" + tabItem + "']");
            container.find('.tab-list--panel.active').removeClass('active');
            panelItem.addClass('active');
        });

        if ($('.tab-list').length) {
            $('.tab-list').each(function () {
                $(this).find('.tab-list--item').first().find('a').click();
            });
        }
        
        /* 21.1 TAB LIST ACCORDION - HASH CHECKING
------------------------------------------*/
        $(document).ready(function () {
            if (window.location.hash) {
                // only do this if there's a tab-list on the page, otherwise do the usual anchor behaviour
                if ($('.tab-list').length) {
                    var hash = decodeURIComponent(window.location.hash.substr(1));
                    var tabNumber = hash.slice(-1) - 1;
                    $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

                    var $container = $("html,body");
                    var $scrollTo = $('.tab-list');

                    window.location.hash = '';

                    $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);

                }
            }
        });

        /* 21.2 TAB LIST ACCORDION - ON PAGE LINKS
------------------------------------------*/
        $(document).ready(function () {
            $('.js-tab-link').on('click', function () {
                //console.group('click');
                var hash = this.hash;
                //console.group(hash);
                var tabNumber = hash.slice(-1) - 1;
                //console.groupEnd(tabNumber);
                $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

                var $container = $("html,body");
                var $scrollTo = $('.tab-list');

                $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);
            });
        });


        /* 22. DROP DOWN NAV SUB MENU HEIGHT
------------------------------------------*/
        if ($('#sub-nav.main-sub').length) {
            var subHeight = $('#sub-nav.main-sub').outerHeight();
            var subNavOffset = subHeight;
            //$('ul#main-nav li > .sub-nav').css('bottom', '-' + subNavOffset +'px');
            $('ul#main-nav li > .sub-nav').css('min-height', (subNavOffset-20)+'px');
        }

    } //if ($('.scChromeToolbar').length) {


    /* 21. SEARCH PAGE REMOVE TEXT
    ------------------------------------------*/
    $('.js-remove-search-term').on('click', function () {
        $(this).prev('.js-search-term').val('');
        $(this).removeClass('is-shown');
    });

    checkSearchTerm();

    $('.js-search-term').bind('change keydown keyup', function () {
        checkSearchTerm();
    });

    function checkSearchTerm() {
        if ($('.js-search-term').val()) {
            $('.js-remove-search-term').addClass('is-shown');
        } else {
            $('.js-remove-search-term').removeClass('is-shown');
        }
    }


});